export default{
    tukeExplore: {
        accountChain: 'アカウントチェーン',
        bussnessChain: 'ビジネスチェーン',
        posChain: 'PoSチェーン',
        enterTheThinkiumDAPPWebAddress: 'DappのURLを入力してください',
        favorites: 'お気に入り',
        noDappCollection: 'DAppをお気に入りに追加していません、お気に入りに移動してください〜',
        openDappAndCollect: 'DAppを開き、右上隅にある[お気に入り]をクリックします。',
        recommend: '推奨',
        Organization: '組織',
        orgDesc: '組織に参加する',
        go:'試み',
    },
}